// extracted by mini-css-extract-plugin
module.exports = {"comp":"FaqA_comp__LhAsM"};